(function(){
  if(window.__bf)return;window.__bf=1;
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.15,rootMargin:'0px 0px -40px 0px'}):null;
  var vio=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){});}else{v.pause();}});},{threshold:.4}):null;
  function init(root){
    root=root||document;
    root.querySelectorAll('.bf-rv,.bf-hero').forEach(function(el){io?io.observe(el):el.classList.add('is-in');});
    root.querySelectorAll('[data-bf-auto] video').forEach(function(v){vio&&vio.observe(v);});
    root.querySelectorAll('[data-bf-drag]').forEach(function(s){
      if(s.__d)return;s.__d=1;var down=false,x=0,l=0;
      s.addEventListener('mousedown',function(e){down=true;x=e.pageX;l=s.scrollLeft;s.style.cursor='grabbing';});
      window.addEventListener('mouseup',function(){down=false;s.style.cursor='';});
      s.addEventListener('mousemove',function(e){if(!down)return;e.preventDefault();s.scrollLeft=l-(e.pageX-x);});
    });
  }
  function bfAdd(id,b,qty){
    if(b){b.disabled=true;b.dataset.t=b.innerHTML;b.innerHTML='…';}
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:+(qty||1)}]})})
    .then(function(r){if(!r.ok)throw r;return r.json();})
    .then(function(){
      if(window.T4SThemeSP&&T4SThemeSP.Cart&&T4SThemeSP.Cart.getToFetch){T4SThemeSP.Cart.getToFetch(true);document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));return;}
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      var t=document.querySelector('a[href$="/cart"][data-drawer-options],[data-drawer-options*="mini_cart"]');
      if(t){t.click();}else{window.location.href='/cart';}
    })
    .catch(function(){window.location.href='/cart';})
    .finally(function(){if(b){b.disabled=false;b.innerHTML=b.dataset.t;}});
  }
  window.bfAdd=bfAdd;
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches||!f.matches('form[data-bf-add]'))return;
    e.preventDefault();
    var q=f.querySelector('[name=quantity]');bfAdd(f.querySelector('[name=id]').value,f.querySelector('button'),q?q.value:1);
  },true);
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-bf-add-id]');if(!b)return;
    e.preventDefault();e.stopPropagation();bfAdd(b.getAttribute('data-bf-add-id'),b,1);
  },true);
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',function(){init();});
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  if(window.Shopify&&Shopify.designMode)document.documentElement.classList.add('bf-design');
})();
